import { z } from 'zod';

import { formatSupportedFormats } from 'screens/Agent/sections/Additional/Ringtone/utils';

// General guidelines: https://www.figma.com/design/hxWFhpuiIGyKdx5U32OCpC/UX-Writing-Guidelines?node-id=3037-39&t=Jkk2J7sXXGj1PvbN-1

export const ERRORS = {
  unknown:
    'Something went wrong. Please wait a few seconds and then try again.',
  required: 'This field is required.',
  invalid_type: 'That data doesn’t look right. Check it and try again.',
  max: (value: number) => `It must be under ${value} characters.`,
  requiredOn: (value: string) =>
    `This field is required because "${value}" was selected.`,
  handoff: {
    description: {
      invalidFormat:
        'It must only contain alphanumeric characters with an optional + at the start.',
      invalidInput:
        'Value should only contain alphanumerics and some punctuation.',
    },
  },
  extension: {
    invalidTypeError: 'It must be a number.',
  },
  disclaimer: {
    max: (size: number) =>
      `File size must be less than ${size / (1024 * 1024)} MB`,
    unsupportedFormat: (supportedFormats: string[]) =>
      `File must have a ${formatSupportedFormats(supportedFormats)} extension`,
  },
  topic: {
    forbidden: `Value can't contain the separator character "|"`,
  },
};

export const customErrorMap: z.ZodErrorMap = (error, ctx) => {
  switch (error.code) {
    case z.ZodIssueCode.invalid_type:
      if (error.expected === 'string') {
        return { message: ERRORS.invalid_type };
      }
      break;
  }

  // fall back to default message
  return { message: ctx.defaultError };
};
